import { AlertBanner } from "@wojo/ui";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import React from "react";
import { useTourPageContext } from "../../../_client/context";
dayjs.extend(utc);

export const QuoteMarketingBanner: React.FC = () => {
    const { pageConfig } = useTourPageContext();
    const message = pageConfig.tripBuilderMarketingBanner;

    if (!message) {
        return null;
    }

    return (
        <AlertBanner status="info" style={{ borderRadius: 0 }}>
            {message}
        </AlertBanner>
    );
};
